export default __webpack_public_path__ + "static/media/clientImg.0a6aaf39.png";